export enum StoriesTypes {
  NoStory = 0,
  receiptScreen = "receipt-screen",
  OrganSelection = "organ-selection",
  okScreenSpinner = "ok-screen-spinner",
  cantPayWithCheck = "cant-pay-with-check",
  ReceiptMechanism = "Receipt Mechanism",
  Contribution = "Contribution",
  ChildPopup = "child-popup",
  Spinner = "spinner",
  UserPopup = "user-popup",
  EventCollection = "Event-Collection",
  DiscountTable = "Discount Table",
  FreePay = "Free Pay",
  ChartModal = "Chart Modal",
  DisableScrollInput = "disable-scroll-input",
  OrDev = "or-dev",
  CodeCubes = "code-cubes",
}



// WEBPACK FOOTER //
// ./src/app/development/stories/stories-types.ts